import type { IOrganisation } from 'src/types/nya/common';

/**
 * Id:t på "organisationen" Alla organisationer — appens standardläge. Det är en
 * attrapp: ingen rad i organisationstabellen, inte ens ett UUID, och finns bara
 * för att organisationsväljaren ska kunna visa ett läge som inte är en enskild
 * förening.
 *
 * Därför får det aldrig nå backend: hamnar det i en org-scopad URL misslyckas
 * UUID-bindningen, och skickas det som `X-Organisation-Id` avvisas det med 400.
 * Av det skälet lämnar {@link useAppContext} ut `organisation: undefined` i det
 * här läget — se `app-context-provider.tsx`. Behöver du veta vad användaren
 * faktiskt valt (namn, typ) finns `valdOrganisation` och `ärAllaOrganisationer`.
 *
 * Hette tidigare `privatperson` och var ett tomt läge som bara bad användaren
 * välja en förening. Lägets *id* är det enda som bytt betydelse — se
 * `organisationsTyp` nedan.
 */
export const ALLA_ID = 'alla';

/** Id:t läget hette före omdöpningen. Finns kvar enbart för migreringen av sparade val. */
export const TIDIGARE_PRIVATPERSON_ID = 'privatperson';

export const ALLA_ORG: IOrganisation = {
  id: ALLA_ID,
  organisationsNamn: 'Alla organisationer',
  organisationsNummer: '',
  momsregisteringsnummer: '',
  /**
   * Medvetet oförändrad från privatpersonsläget. `PRIVATPERSON` är här en
   * *organisationstyp* och inget lägesnamn: regelmotorn i `myndighetsdatum.ts`
   * bygger personens egna deklarationsdatum — Inkomstdeklaration 1, fastighets-
   * avgift — på just den typen. Den som ser hubben är fortfarande en
   * privatperson med egna förfallodagar, oavsett hur många föreningar hen är
   * med i.
   */
  organisationsTyp: 'PRIVATPERSON',
  adress: {
    gata: '',
    nr: '',
    våning: '',
    postNummer: '',
    ort: '',
    fullständigAdress: null,
  },
  räkenskapsår: [],
};

/**
 * Sant för hubbläget. Tar även det gamla id:t: ett anrop kan gå iväg innan
 * migreringen i `app-context-provider.tsx` hunnit skriva om sparade val, och
 * ett `privatperson` som slinker förbi hit blir ett 400-svar från backend.
 */
export function ärAllaId(orgId?: string | null): boolean {
  return orgId === ALLA_ID || orgId === TIDIGARE_PRIVATPERSON_ID;
}
